import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { IntroKeys } from 'components/app/intro/intro-keys';
import { selectStats } from 'components/app/editor/_mediator/editor.slice';
import styles from './_editor-stats.module.scss';

type Props = {
  itemsName: string;
  className?: string;
};

export const EditorStats = ({ itemsName, className }: Props) => {
  const stats = useAppSelector(selectStats);
  return (
    <div className={cm(styles.Stats, className)} data-intro={IntroKeys.srStats}>
      <p>
        Number of {itemsName}: {stats?.numberOfClips}
      </p>
      <p>Max: {stats?.max}</p>
      <p>Available: {stats?.available}</p>
    </div>
  );
};
